import React, {Component, Fragment} from 'react'
import classNames from 'classnames'
import ListItem from '@material-ui/core/ListItem'
import Badge from '@material-ui/core/Badge'
import ListItemText from '@material-ui/core/ListItemText'
import styled from 'styled-components'
import Tooltip from '@material-ui/core/Tooltip'
import {Link} from "react-router-dom";

const ContainerIcon = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    ${props => props.color && `svg{fill: ${props.color};stroke: ${props.color};}`}
    ${props => props.badgeColor && `background:red!important; span.badge {background-color: ${props.badgeColor};!important}`}
`


const ContainerColor = styled.div`
${props => props.badgeColor && `&.active >div >span.badge {background-color: ${props.badgeColor}!important;}`}
`
const Container = styled.div`
        width: 100%;
        display: flex;
        align-items: center;
        .secondary{
            margin-left: auto;
            color: inherit;
            font-weight: bold;
            width: 25px;
            text-align: center;
        }
        ${props => props.color && `background: red;`}
        .badge_root {
            position: absolute;
            right: 0;
            top: 0;
        }
        .container {
            display: flex;
            padding: 0;
            margin: 0;
            align-items: baseline;
        }
        .badge_expired {
            color: #fff;
            background-color: #F44336;
        }
        .content{
            font-weight: 500;
        }`

class Item extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const {disabled, badgeColor, title, icon, active, tooltip, value, badge,badgeExpired, tooltipPos, to, colorBase, ...props} = this.props

        const LiContent = title ?
            <Container>
                {(icon && badge) ?
                    <Fragment>
                        <Badge badgeContent={badge} component='div' classes ={{badge: 'badge', root: 'badge_root'}}/>
                        {icon}
                        {Number(badgeExpired) > 0 && <div className='badge_expired MuiBadge-badge content MuiBadge-anchorOriginBottomRightRectangle'>{badgeExpired}</div>}
                    </Fragment> : icon && icon}
                <ListItemText component="span" primary={title} secondary={value} classes={{root: 'container'}}/>
            </Container> : icon && badge ?
                <ContainerColor className={classNames({active: !!active})} badgeColor={badgeColor}><Badge
                    badgeContent={badge} component='div'
                    classes={{badge: 'badge'}}>{icon}</Badge></ContainerColor> : icon

        const Li = <ListItem style={{color: colorBase}} disabled={disabled} component="li" button {...props}
                             className={classNames({active: !!active, link: !!to, icon: !!icon}, this.props.className)}>
            {to ? <Link to={to}>{LiContent}</Link> : <ContainerIcon color={colorBase}>{LiContent}</ContainerIcon>}
        </ListItem>

        return (
            tooltip ? <Tooltip title={tooltip} placement={tooltipPos ? tooltipPos : 'right'}>
                {Li}
            </Tooltip> : Li
        )
    }
}

export default Item